const PATH = "https://drive.google.com/uc?id=";

const changeImageUrl = (url) => {
  if (url) {
    let imgId = url?.split("d/", 2);

    let idFinal = imgId[1]?.split("/", 1);

    return `${PATH}${idFinal}`;
  }
  return "";
};

export default changeImageUrl;
